/* eslint-disable react/jsx-pascal-case */
import React from 'react'
import styled from 'styled-components'
import propTypes from 'prop-types'
import currency from '../../../helpers/currency'
import { Box, Typography } from '@material-ui/core'

const Summary = (props) => {
  if (props.currentStep !== 3) return null

  return (
    <Container>
      <Title>{props.title}</Title>
      <Picture src={typeof props.picture === 'string' ? props.picture : props.picture.preview} />
      <Price>$ {currency.formatMoney(props.price)} MN</Price>
      {props.description && (
        <Box>
          <Typography variant='subtitle1' color='secondary'>Descripción</Typography>
          <Description__ dangerouslySetInnerHTML={{ __html: props.description }} />
        </Box>
      )}
      {props.indications && (
        <Box>
          <Typography variant='subtitle1' color='secondary'>Indicaciones</Typography>
          <Description dangerouslySetInnerHTML={{ __html: props.indications }} />
        </Box>
      )}
      {props.process && !!props.process.length && (
        <Box>
          <Typography variant='subtitle1' color='secondary'>Procedimiento</Typography>
          <Description as='ol'>
            {props.process.map((step, index) => (
              <li style={{ marginBottom: '15px' }} key={index}>{step}</li>
            ))}
          </Description>
        </Box>
      )}
    </Container>
  )
}

Summary.propTypes = {
  currentStep: propTypes.number,
  title: propTypes.string,
  description: propTypes.string,
  price: propTypes.number,
  picture: propTypes.oneOfType([propTypes.object, propTypes.string]),
  indications: propTypes.string,
  process: propTypes.array
}

const Container = styled('div')`
  max-width: 600px;
  margin: auto;
  margin-top: 25px;
  margin-bottom: 25px;
`
const Title = styled('h2')`
  font-weight: bold;
  font-size: 1.7em;
  color: var(--main-blue-dark);
`
const Picture = styled('img')`
  border-radius: 5px;
  width: 100%;
  height: 450px;
  object-fit: cover;
  margin: auto;
  display: block;
  margin: 20px 0px;
  @media (max-width:1000px) {
    height: 350px;
  }
  @media (max-width:700px) {
    height: 300px;
  }
`
const Price = styled('h1')`
  font-weight: bold;
  font-size: 1.7em;
  color: var(--main-blue-dark);
`
const Description = styled('p')`
  color: var(--main-blue-dark);
  font-size: 1em;
`

const Description__ = styled(Description)`
  p, li {
    line-height: initial;
  }
`

export default Summary
